import { IMG_URL } from "configs";
import { twMerge } from "tailwind-merge";

export default function Image({ src, alt, className, ...props }) {
  return (
    <img src={`${IMG_URL}/${src}`} alt={alt} className={twMerge("block", className)} {...props} />
  );
}
